import { useEffect, useState } from 'react';
import {
  getCalendarFocusedValue,
  type CalendarFocusedValueInput
} from './calendarFocusedValueUtils';

/**
 * Controlled focused month for Spectrum Calendar: opens on the target month/quarter
 * while still allowing prev/next navigation via onFocusChange.
 */
export function useCalendarFocusedValue({
  selectedDate,
  startMonth,
  startMonthYear,
  startQuarter
}: CalendarFocusedValueInput) {
  const [focusedValue, setFocusedValue] = useState(() =>
    getCalendarFocusedValue({
      selectedDate,
      startMonth,
      startMonthYear,
      startQuarter
    })
  );

  useEffect(() => {
    setFocusedValue(
      getCalendarFocusedValue({
        selectedDate,
        startMonth,
        startMonthYear,
        startQuarter
      })
    );
  }, [selectedDate, startMonth, startMonthYear, startQuarter]);

  return { focusedValue, onFocusChange: setFocusedValue };
}
